import { Container, type ContainerProps } from "@chakra-ui/react";
import React from "react";

export interface VaultContainerProps extends ContainerProps {
  children?: React.ReactNode;
}

/**
 * VaultContainer - Consistent container wrapper for V2 vault pages
 *
 * Provides standardized padding and max-width for all vault pages.
 * Max width set to 560px for optimal mobile/tablet experience.
 * Horizontally centered with responsive vertical padding:
 * - Mobile: py="4", px="4"
 * - Desktop (lg+): py="12", px="4"
 * Accepts all Chakra UI Container props for customization.
 */
export const VaultContainer: React.FC<VaultContainerProps> = ({ children, ...props }) => {
  return (
    <Container maxW="560px" px="4" py={{ base: 4, lg: 12 }} w="full" {...props}>
      {children}
    </Container>
  );
};
